import { Button, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { RefreshIcon } from "../icons/ActionIcons";

export default function RefreshButton({
  buttonProps = {
    variant: "outlined",
    color: "primary",
  },
  iconProps = {},
  tooltipProps = {},
  onClick = () => {},
  noPrint = true,
}) {
  return (
    <div className={noPrint ? "noPrint" : ""}>
      <Tooltip disableInteractive {...tooltipProps}>
        <span>
          <Button {...buttonProps} onClick={onClick}>
            <RefreshIcon {...iconProps} />
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}

RefreshButton.propTypes = {
  buttonProps: PropTypes.object,
  iconProps: PropTypes.object,
  onClick: PropTypes.func,
  tooltipProps: PropTypes.object,
  noPrint: PropTypes.bool,
};
